import { useState } from "react";

export const useExportClientGridData = (
  apiGetEndpoint,
  apiParameters, 
  gridErrorHandlerCallback
) => {
  const [exportFormat, setExportFormat] = useState("");
  const [exportColumns, setExportColumns] = useState(null);
  const [fullExportData, setFullExportData] = useState(null);
  const [runningExportData, setRunningExportData] = useState(false);

  function ExportHasCompleted() {
    setRunningExportData(false);
    setFullExportData([]);
  }

  function InitiateExport(format, columns, data) {
    setRunningExportData(true);

    setExportColumns(columns);
    setExportFormat(format);
    setFullExportData(data);
  }

  const handleExportError = (error) => {
    setRunningExportData(false);
    if (gridErrorHandlerCallback) {
      gridErrorHandlerCallback(error);
    } else {
      console.error("Export error:", error);
    }
  };

  return {
    exportColumns,
    exportFormat,
    fullExportData,
    runningExportData,
    InitiateExport,
    ExportHasCompleted,
  };
};
